module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar2-fill-c9f600bd.svg";